import { queryClient } from '@hotjar/webapp/utils/react-query';
import {
  HEATMAP_HIGHLIGHTS_LIST_QUERY_KEY,
  HIGHLIGHTS_LIST_QUERY_KEY,
  SINGLE_HIGHLIGHT_QUERY_KEY,
} from '@hotjar/webapp/domains/highlights/api';

export const invalidateQuery = {
  onPut: (): void => {
    queryClient.invalidateQueries(HEATMAP_HIGHLIGHTS_LIST_QUERY_KEY);
    queryClient.invalidateQueries(HIGHLIGHTS_LIST_QUERY_KEY);
  },
  onPost: (): void => {
    queryClient.invalidateQueries(HIGHLIGHTS_LIST_QUERY_KEY);
    queryClient.invalidateQueries(HEATMAP_HIGHLIGHTS_LIST_QUERY_KEY);
    queryClient.invalidateQueries(SINGLE_HIGHLIGHT_QUERY_KEY);
  },
  onPostReply: (): void => {
    queryClient.invalidateQueries(HIGHLIGHTS_LIST_QUERY_KEY);
  },
  onRemoveSetThreads: (): void => {
    queryClient.invalidateQueries(HEATMAP_HIGHLIGHTS_LIST_QUERY_KEY);
    queryClient.invalidateQueries(SINGLE_HIGHLIGHT_QUERY_KEY);
  },
  onRemove: (): void => {
    queryClient.invalidateQueries(HIGHLIGHTS_LIST_QUERY_KEY);
  },
};
